import { Injectable } from "@angular/core";
import { Observable, Observer, forkJoin } from "rxjs";


@Injectable()
export class ScriptLoaderService {
    private scripts: ScriptModel[] = [];

    public loadMany(scripts: ScriptModel[]) : Observable<ScriptModel>[]{
        return scripts.map(c => this.load(c));
    }
    public load(script: ScriptModel): Observable<ScriptModel> {
        return new Observable<ScriptModel>((observer: Observer<ScriptModel>) => {
            var existingScript = this.scripts.find(s => s.name == script.name);

            // Complete if already loaded
            if (existingScript && existingScript.loaded) {
                observer.next(existingScript);
                observer.complete();
            }
            else {
                // Add the script
                this.scripts = [...this.scripts, script];

                // Load the script
                let scriptElement = document.createElement("script");
                scriptElement.type = "text/javascript";
                if(script.src){
                    scriptElement.src = script.src;
                }

                if(script.content){
                    scriptElement.innerHTML = script.content;
                }

                scriptElement.onload = () => {
                    script.loaded = true;
                    observer.next(script);
                    observer.complete();
                    
                };

                scriptElement.onerror = (error: any) => {
                    observer.error("Couldn't load script " + script.src);
                };

                document.getElementsByTagName('body')[0].appendChild(scriptElement);
            }
        });
    }
}

export interface ScriptModel {
    name: string,
    src?: string,
    content?:string,
    loaded: boolean
}